import { render, staticRenderFns } from "./chatbotServices.vue?vue&type=template&id=80c9facc&scoped=true&"
import script from "./chatbotServices.vue?vue&type=script&lang=js&"
export * from "./chatbotServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c9facc",
  null
  
)

export default component.exports